import {AbstractReactComponent, i18n, Icon} from 'mc/lib';
import {FeatureEditor, FeatureEditorActions} from 'mc/lib/mapio';
import {ModalActions} from 'mc/lib/modal';
import {objectById} from 'mc/lib/utils';
import React from 'react';
import {connect} from 'react-redux';
import {browserHistory, Link} from 'react-router';
import {Button, Card, Col, FormGroup, Label, Row} from 'reactstrap';
import {CurrentZadostActions} from '../../actions';
import {Api} from '../../api';
import {PrilohaDeclaration, ZadostStav} from '../../enums';
import {Loading} from '../common';
import {getFeaturesFromLokalitaList} from '../lokalita';
import {formatSubjekt} from '../subjekt';
import ZadostBackButton from './ZadostBackButton';
import ZadostFooter from './ZadostFooter';
import ZadostLayout from './ZadostLayout';
import ZadostNextButton from './ZadostNextButton';
import './ZadostShrnuti.scss';

const featureEditorArea = 'zadostShrnutiFeatureEditor';

class ZadostShrnuti extends AbstractReactComponent {

    id = null;

    state: {
        id: number,
        editorHeight:?number
    } = {
        id: parseInt(this.props.params.id),
        editorHeight: null
    };

    constructor(props) {
        super(props);

        const {zadost} = props;
        this.initialFeatures = zadost ? getFeaturesFromLokalitaList(zadost.lokalitaList) : [];
    }

    componentDidMount() {
        const newState = {editorHeight: this.getEditorHeight()};
        if (isNaN(this.state.id)) {
            browserHistory.push(serverContextPath);
        } else {
            this.setState({...newState});
        }
        this.dispatch(CurrentZadostActions.fetchIfNeeded(this.state.id, true, true, true));
    }

    componentDidUpdate(prevProps) {
        const editorHeight = this.getEditorHeight();

        if (this.state.editorHeight !== editorHeight) {
            this.setState({editorHeight});
        }

        const {zadost, dispatch} = this.props;
        if (zadost && zadost !== prevProps.zadost) {
            dispatch(FeatureEditorActions.loadFeatures(featureEditorArea, getFeaturesFromLokalitaList(zadost.lokalitaList)));
        }
    }

    getEditorHeight = () => {
        if (window.innerWidth >= 992) {
            const wind = window.innerHeight;
            const header = outerHeight(document.getElementById('header'));
            const stage = document.getElementById('stage');

            let stageHeight = 40;
            if (stage) {
                stageHeight = stage.offsetHeight;
            }
            const heading = document.getElementById('heading');
            let headingHeight = 70;
            if (heading) {
                headingHeight = outerHeight(heading);
            }
            const footer = document.getElementById('footer');
            let footerHeight = 50;
            if (footer) {
                footerHeight = footer.offsetHeight;
            }
            return wind - header - footerHeight - stageHeight - headingHeight - 15;
        }
        return null;
    };

    componentWillUnmount() {
        this.dispatch(CurrentZadostActions.invalidate());
    }

    submit = () => {
        this.dispatch(ModalActions.showConfirm(i18n('zadostShrnuti.accept.confirm.title'), i18n('zadostShrnuti.accept.confirm.message'), () => {
            return Api.closeZadost(this.state.id).then(() => {
                this.dispatch(ModalActions.showInfo(i18n('zadostShrnuti.accept.done.title'), <div>
                    <p>{i18n('zadostShrnuti.accept.done.message')}<strong>{this.props.zadost.refCislo.match(/.{4}/g).join('-')}</strong></p>
                    <Button color="link" type="button" onClick={this.handlePrintPdf}>
                        {i18n('zadostShrnuti.accept.done.message.button')}
                    </Button>

                    <p className="doruceni-info">
                        <strong>{i18n('zadostShrnuti.accept.done.messagedoruceni')}</strong>
                        <Button color="link" type="button" onClick={() => window.open("https://www.mojedatovaschranka.cz")}>
                            {i18n('zadostShrnuti.accept.done.databox.button')}
                        </Button>
                    </p>

                </div>, () => {
                    browserHistory.push(serverContextPath);
                }));
            });
        }))
    };

    renderPriloha = typPriloha => {
        const {zadost} = this.props;
        const priloha = objectById(zadost.prilohaList, typPriloha.id, 'idTypPriloha');
        const stav = priloha ? priloha.stav : null;
        const stavDecided = PrilohaDeclaration.isDecided(stav);

        return <Row key={"priloha-" + typPriloha.id}>
            <Col xs={12}>
                <Row>
                    <Col xs={12}>
                        <h4 className="pull-left">
                            <Icon className="align-middle" icon={stavDecided ? 'check-square-o' : 'square-o'} fixedWidth/>
                            {' '}
                            <span className="align-middle">{typPriloha.nazev}</span>
                        </h4>
                    </Col>
                </Row>
                {typPriloha.popis && <p>{typPriloha.popis}</p>}
                {stavDecided ? (
                    <p>
                        {stav === PrilohaDeclaration.Digital ? (
                            <a href={serverContextPath + "/api/zadost/" + zadost.id +"/priloha/" + typPriloha.id} target="_blank">
                                <Icon icon="download"/> {priloha.nazev}
                            </a>
                        ) : (
                            <em>{i18n('zadostShrnuti.declaration.' + stav)}</em>
                        )}
                    </p>
                ) : (
                    <Link to={serverContextPath + '/zadost/' + this.state.id + '/nalezitosti'} className="text-danger no-decoration">
                        {i18n('zadostShrnuti.declaration.undecidedErr')}
                    </Link>
                )}
            </Col>
        </Row>
    };

    renderSubjektRole = roleSubjekt => {
        const zukpSubjekt = objectById(this.props.zadost.subjektList, roleSubjekt.id, 'idRoleSubjekt');
        if (!zukpSubjekt && !roleSubjekt.povinna) {
            return null;
        }
        return <Row key={"role-" + roleSubjekt.id}>
            <Col xs={12}>
                <FormGroup>
                    <Label>{roleSubjekt.nazev}</Label>
                    {zukpSubjekt ? (
                        <div>{formatSubjekt(zukpSubjekt.subjekt)}</div>
                    ) : (
                        <div>
                            <Link to={serverContextPath + '/zadost/' + this.state.id + '/nalezitosti'} className="text-danger no-decoration">
                                {i18n('zadostShrnuti.noRoleSubjekt', roleSubjekt.nazev)}
                            </Link>
                        </div>
                    )}
                </FormGroup>
            </Col>
        </Row>
    };

    isValid() {
        const {zadost} = this.props;
        return zadost.zadatel
            && zadost.lokalitaList.length > 0
            && this.isPrilohaListValid()
            && this.isSubjektListValid();
    }

    isPrilohaListValid() {
        const {zadost: {typZabor: {typPrilohaList}, prilohaList}} = this.props;
        for (const typPriloha of typPrilohaList) {
            if (!prilohaList.some(({idTypPriloha, stav}) => typPriloha.id === idTypPriloha && PrilohaDeclaration.isDecided(stav))) {
                return false;
            }
        }
        return true;
    }

    isSubjektListValid() {
        const {zadost: {typZabor: {roleSubjektList}, subjektList}} = this.props;
        for (const roleSubjekt of roleSubjektList) {
            if (roleSubjekt.povinna && !subjektList.some(({idRoleSubjekt}) => roleSubjekt.id === idRoleSubjekt)) {
                return false;
            }
        }
        return true;
    }

    handlePrintPdfPreview = () => {
        this.printPdf(true);
    };

    handlePrintPdf = () => {
        this.printPdf(false);
    };

    printPdf = preview => {
        window.open(`${serverContextPath}/api/zadost/${this.state.id}/print/pdf?preview=${preview}`);
    };

    render() {
        const {zadost, typZabor} = this.props;
        if (!zadost || zadost.lokalitaList === null || zadost.prilohaList === null || !typZabor) {
            return <Loading block="full"/>;
        }
        const {roleSubjektList, druhUcelList, typPrilohaList} = typZabor;

        return <ZadostLayout className="zadost-shrnuti" stage={4}>
            <Row>
                <Col xs={12}>
                    <h1 id="heading" style={{marginBottom:'20px'}}>{i18n('zadostShrnuti.title')}</h1>
                    <Row>
                        <Col xs={12} lg={8}>
                            <Card block>
                                <Row className="section">
                                    <Col xs={12}>
                                        <Row>
                                            <Col xs={12} sm={4} md={2}>{i18n('zadostShrnuti.typZadost')}</Col>
                                            <Col xs={12} sm={8} md={10}><h3 style={{marginTop:0}} className="typ"><img
                                                src={serverContextPath + "/img/" + typZabor.ikona}/> {typZabor.nazev}
                                            </h3></Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} sm={4} md={2}>{i18n('zadostShrnuti.refNumber')}</Col>
                                            <Col xs={12} sm={8} md={10}>
                                                <p>{zadost.refCislo.match(/.{4}/g).join('-')}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="section">
                                    <Col xs={12}>
                                        {typZabor.popis && <Row>
                                            <Col xs={12} sm={4} md={2}>{i18n('zadostShrnuti.popis')}</Col>
                                            <Col xs={12} sm={8} md={10}>
                                                <p>{typZabor.popis}</p>
                                            </Col>
                                        </Row>}
                                        <Row style={{marginBottom:'10px'}}>
                                            <Col xs={12} sm={4} md={2}>{i18n('zadostShrnuti.ucely')}</Col>
                                            <Col xs={12} sm={8} md={10} className="ucely">
                                                {druhUcelList.map((i, index) => <span className="ucel"
                                                                                      key={"ucel-" + index}>{i.nazev}</span>)}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="section subjekty">
                                    <Col xs={12} sm={4} md={2}>{i18n('zadostShrnuti.requiredInfo')}</Col>
                                    <Col xs={12} sm={8} md={10}>
                                        <Row key="zadatel">
                                            <Col xs={12}>
                                                <FormGroup>
                                                    <Label>{i18n('zadostShrnuti.applicant')}</Label>
                                                    <div>{zadost.zadatel ? formatSubjekt(zadost.zadatel) : <Link
                                                        to={serverContextPath + '/zadost/' + this.state.id + '/nalezitosti'}
                                                        className="text-danger no-decoration">{i18n('zadostShrnuti.noApplicant')}</Link>}</div>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {roleSubjektList.map(this.renderSubjektRole)}
                                    </Col>
                                </Row>
                                <Row className="section">
                                    <Col xs={12} sm={4} md={2}>{i18n('zadostShrnuti.requiredAttachments')}</Col>
                                    <Col xs={12} sm={8} md={10}>
                                        {typPrilohaList.map(this.renderPriloha)}
                                    </Col>
                                </Row>
                                {this.isValid() && <Row>
                                    <Col xs={12} sm={{size: true, offset: 4}} md={{size: true, offset: 2}}>
                                        <Button type="button" color="primary" onClick={this.handlePrintPdfPreview}>
                                            <Icon icon="eye"/> {i18n('zadostShrnuti.pdfPreview')}
                                        </Button>
                                    </Col>
                                </Row>}
                            </Card>
                        </Col>
                        <Col xs={12} lg={4}>
                            <FeatureEditor area={featureEditorArea}
                                           initialFeatures={this.initialFeatures}
                                           color={[233, 47, 102]}
                                           readOnly/>
                        </Col>
                    </Row>
                </Col>
                <ZadostFooter>
                    <ZadostBackButton path={`/zadost/${zadost.id}/zakres`}/>
                    {zadost.stav === ZadostStav.R && (
                        <ZadostNextButton disabled={!this.isValid()} onClick={this.submit}>
                            {i18n('zadostShrnuti.accept')}
                        </ZadostNextButton>
                    )}
                </ZadostFooter>
            </Row>
        </ZadostLayout>
    }
}


function outerHeight(el) {
    const style = getComputedStyle(el);
    return el.offsetHeight + parseInt(style.marginTop) + parseInt(style.marginBottom);
}

const mapStateToProps = state => {
    const {app:{currentZadost: {data}}} = state;
    return {
        zadost: data,
        typZabor: data ? data.typZabor : null,
    };
};

export default connect(mapStateToProps)(ZadostShrnuti);
